<template>
    <div class="boxlogo">
        <div class="brand">
            <img class="logo" :src="require('@/assets/images/img/logo_dt.png')" />
            <span class="brand-divider"></span>
            <div class="brand-text">
                <h1 class="brand-title">FreshMon Pulse</h1>
                <p class="brand-subtitle">ALWAYS FRESH · ALWAYS IN CONTROL</p>
            </div>
        </div>
        <div class="login_in_wrap">
            <section class="login_in">
                <h2 class="loginTitle">{{ $t('accountRedesign.forget_password_title') }}</h2>
                <p class="loginTip">{{ $t('accountRedesign.forget_password_tip') }}</p>

                <el-form
                    autocomplete="on"
                    :model="form"
                    :rules="rules"
                    ref="form"
                    class="login_form"
                    label-position="left"
                    @submit.native.prevent
                >
                    <el-form-item prop="email">
                        <el-input
                            name="email"
                            type="text"
                            v-model.trim="form.email"
                            autocomplete="off"
                            :placeholder="$t('accountRedesign.placeholder_email')"
                        >
                            <i slot="prefix" class="el-icon-message"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="validateCode">
                        <div class="flexbox">
                            <el-input
                                type="text"
                                :placeholder="$t('accountRedesign.placeholder_captcha')"
                                @keyup.native.enter="handleSubmit"
                                class="validateText"
                                v-model="form.validateCode"
                            >
                                <i slot="prefix" class="el-icon-key"></i>
                            </el-input>
                            <div @click="changeCode()" class="voliade">
                                <identify :identifyCode="identifyCode"></identify>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button :loading="loading" :disabled="disabled" @click="handleSubmit">
                            {{ $t('accountRedesign.btn_send_reset_link') }}
                        </el-button>
                    </el-form-item>
                    <el-form-item class="registy-item">
                        <div class="lang-switch" @click="toggleLang" :title="currentLang === 'zh_CN' ? 'Switch to English' : '切换到中文'">
                            <span class="lang-option" :class="{ active: currentLang === 'zh_CN' }">中</span>
                            <span class="lang-option" :class="{ active: currentLang === 'en_US' }">EN</span>
                            <span class="lang-slider" :class="{ 'is-en': currentLang === 'en_US' }"></span>
                        </div>
                        <div class="links-group">
                            <span class="forget-link" @click="goLogin">{{ $t('accountRedesign.link_back_to_login') }}</span>
                        </div>
                    </el-form-item>
                </el-form>
            </section>
            <div class="groove-strip groove-strip-left"></div>
            <div class="groove-strip groove-strip-right"></div>
        </div>
        <div class="login-footer">
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
import identify from '../login/SIdentify'
import Footer from '../layout/Footer.vue'
import { STORAGE_PREFIX } from '@/config/storage'
import { forgetPassword } from '@/api/modules/account.js'

export default {
  name: 'ForgetPassword',
  computed: {
    currentLang () {
      return this.$i18n && this.$i18n.locale
    },
    rules () {
      const identifyCodeFn = (rules, value, callback) => {
        if (this.identifyCode !== value) {
          callback(new Error(this.$t('accountRedesign.err_captcha_incorrect')))
        } else {
          callback()
        }
      }
      return {
        email: [
          {
            required: true,
            message: this.$t('accountRedesign.placeholder_email'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('accountRedesign.placeholder_email'),
            trigger: 'blur'
          }
        ],
        validateCode: [
          {
            required: true,
            message: this.$t('accountRedesign.placeholder_captcha'),
            trigger: 'blur'
          },
          {
            min: 4,
            max: 4,
            message: this.$t('accountRedesign.placeholder_captcha'),
            trigger: 'blur'
          },
          {
            validator: identifyCodeFn,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  components: {
    identify,
    Footer
  },
  data () {
    return {
      form: {
        email: '',
        validateCode: ''
      },
      loading: false,
      disabled: false,
      identifyCode: 'm6a8',
      identifyCodes: '123456789abcdefghjkmnpqrstuvwxyz'
    }
  },
  methods: {
    goLogin () {
      this.$router.push('/login')
    },

    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },

    async handleSubmit () {
      const flag = await this.justify()
      if (!flag) return
      this.loading = true
      this.disabled = true
      const payload = {
        email: this.form.email,
        captcha: this.form.validateCode,
        captchaId: this.identifyCode,
        origin: window.location.origin
      }
      forgetPassword(payload)
        .then((res) => {
          if (res.state && res.state.code === 200) {
            this.$message.success(this.$t('accountRedesign.success_send_reset_link'))
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
          this.disabled = false
          this.changeCode()
          this.form.validateCode = ''
        })
    },

    changeCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    randomNum (min, max) {
      max = max + 1
      return Math.floor(Math.random() * (max - min) + min)
    },
    makeCode (data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)]
      }
    },
    toggleLang () {
      const newLang = this.currentLang === 'zh_CN' ? 'en_US' : 'zh_CN'
      this.$i18n.locale = newLang
      this.$store.dispatch('app/setLanguage', newLang)
      localStorage.setItem(STORAGE_PREFIX + 'lang', newLang)
    }
  },
  mounted () {
    this.identifyCode = ''
    this.makeCode(this.identifyCodes, 4)
  }
}
</script>

<style lang="scss" scoped>
.boxlogo {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 600px;
    overflow: hidden;
    background: url('~@/assets/bg/bg-1.jpg') no-repeat center center;
    background-size: cover;

    .brand {
        position: absolute;
        top: 30px;
        left: 60px;
        z-index: 10;
        display: flex;
        align-items: center;
        gap: 18px;

        .logo {
            height: 72px;
            display: block;
        }

        .brand-divider {
            width: 1px;
            height: 48px;
            background: linear-gradient(to bottom, transparent 0%, rgba(48, 78, 114, 0.45) 50%, transparent 100%);
            flex-shrink: 0;
        }

        .brand-text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            line-height: 1.1;
        }

        .brand-title {
            margin: 0;
            font-family: 'Source Han Sans CN', 'PingFang SC', 'Microsoft YaHei', sans-serif;
            font-size: 26px;
            font-weight: 700;
            letter-spacing: 0.5px;
            color: #1f2937;
            background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-hover) 60%, var(--primary-color) 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .brand-subtitle {
            margin: 6px 0 0 0;
            font-family: 'Helvetica Neue', 'Arial', sans-serif;
            font-size: 11px;
            font-weight: 500;
            letter-spacing: 2.5px;
            color: #6b7280;
            text-transform: uppercase;
        }
    }

    .login-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;

        ::v-deep.el-footer {
            height: 60px !important;
            background: transparent;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        ::v-deep.el-footer span {
            color: rgba(56, 56, 56, 0.85);
        }
    }

    .login_in_wrap {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 5;

            .groove-strip {
                position: absolute;
                top: 45.44%;
                width: 0.84%;
                height: 8.94%;
                background: #ffffff;
                z-index: 6;
                pointer-events: none;
            }

            .groove-strip-left {
                left: 0.21%;
            }

            .groove-strip-right {
                right: 0.21%;
            }
        }

    .login_in {
            position: relative;
            width: 380px;
            background: #ffffff;
            filter: drop-shadow(0 8px 24px rgba(48, 78, 114, 0.18)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.04));
            /* 八边形：四角斜切 + 左右中间连续梯形凹槽 */
            clip-path: polygon(
                3.13% 0%, 96.87% 0%,
                100% 2.68%, 100% 44.36%,
                97.91% 45.26%, 97.91% 54.56%,
                100% 55.46%, 100% 97.32%,
                96.87% 100%, 3.13% 100%,
                0% 97.32%, 0% 55.46%,
                2.09% 54.56%, 2.09% 45.26%,
                0% 44.36%, 0% 2.68%
            );
            padding: 32px 32px 24px 32px;

            .loginTitle {
                text-align: center;
                font-family: 'Source Han Sans CN';
                font-size: 20px;
                font-weight: 600;
                color: #1f2937;
                margin: 0 0 12px 0;
                letter-spacing: 1px;
            }

            .loginTip {
                text-align: center;
                font-size: 12px;
                color: #6b7280;
                line-height: 1.6;
                margin: 0 0 20px 0;
                padding: 0 4px;
            }

            .login_form {
                .el-form-item {
                    margin-bottom: 22px;
                }

                .registy-item {
                    margin-top: 8px !important;
                    margin-bottom: 0 !important;

                    ::v-deep .el-form-item__content {
                        line-height: 1.8 !important;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                }

                /* 忘记密码/注册链接容器：右对齐 */
                .links-group {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-left: auto;
                }

                .forget-link {
                    color: #344962;
                    cursor: pointer;
                    font-size: 13px;
                    border-bottom: 1px solid #344962;
                    transition: all 0.2s ease;

                    &:hover {
                        color: var(--primary-color);
                        border-bottom-color: var(--primary-color);
                    }
                }

                /* 中英文切换 - 滑动式 toggle switch */
                .lang-switch {
                    position: relative;
                    display: inline-flex;
                    align-items: center;
                    width: 72px;
                    height: 28px;
                    padding: 2px;
                    border-radius: 999px;
                    background-color: #eef1f6;
                    cursor: pointer;
                    user-select: none;
                    overflow: hidden;
                    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
                    outline: none;

                    &:focus,
                    &:active {
                        outline: none;
                    }

                    .lang-option {
                        position: relative;
                        z-index: 2;
                        flex: 1;
                        text-align: center;
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 24px;
                        color: #9ca3af;
                        background-color: transparent;
                        transition: color 0.25s ease;

                        &.active {
                            color: #fff;
                            font-weight: 600;
                            background-color: transparent;
                        }
                    }

                    .lang-slider {
                        position: absolute;
                        top: 2px;
                        left: 2px;
                        z-index: 1;
                        width: calc(50% - 2px);
                        height: calc(100% - 4px);
                        border-radius: 999px;
                        background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-hover) 100%);
                        box-shadow: 0 2px 6px rgba(48, 78, 114, 0.35);
                        transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);

                        &.is-en {
                            transform: translateX(100%);
                        }
                    }

                    &:hover .lang-slider {
                        box-shadow: 0 2px 8px rgba(48, 78, 114, 0.5);
                    }
                }

                .el-input {
                    ::v-deep .el-input__inner {
                        height: 46px;
                        line-height: 46px;
                        border: 1px solid #e8ecf1;
                        border-radius: 8px;
                        background-color: #f5f7fa;
                        font-size: 14px;
                        color: #1f2937;
                        padding-left: 44px;
                        transition: all 0.2s ease;

                        &::placeholder {
                            color: #9ca3af;
                        }

                        &:focus {
                            border-color: var(--primary-color);
                            background-color: #ffffff;
                            box-shadow: 0 0 0 3px rgba(48, 78, 114, 0.12);
                        }

                        &:hover {
                            border-color: #9cb4d8;
                        }
                    }

                    ::v-deep .el-input__prefix {
                        left: 0;
                        width: 40px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    ::v-deep .el-input__suffix {
                        height: 100%;
                        display: flex;
                        align-items: center;
                        padding-right: 8px;
                    }

                    ::v-deep .el-input__suffix-inner {
                        display: flex;
                        align-items: center;
                    }

                    ::v-deep .el-input__prefix-inner {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 100%;
                    }

                    ::v-deep .el-icon-message,
                    ::v-deep .el-icon-key,
                    ::v-deep .el-icon-view,
                    ::v-deep .iconfont {
                        font-size: 16px;
                        color: #6b7280;
                    }
                }

                .flexbox {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    width: 100%;

                    > .el-input {
                        flex: 1;
                        min-width: 0;
                    }

                    .voliade {
                        flex-shrink: 0;
                        width: 110px;
                        height: 46px;
                        cursor: pointer;
                        border-radius: 0;
                        overflow: hidden;
                        border: 1px solid #e8ecf1;
                        background-color: #f5f7fa;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all 0.2s ease;

                        &:hover {
                            border-color: var(--primary-color);
                            box-shadow: 0 0 0 3px rgba(48, 78, 114, 0.08);
                        }
                    }
                }

                ::v-deep .el-button {
                    width: 100%;
                    height: 48px;
                    margin-top: 8px;
                    background-color: var(--primary-color) !important;
                    border-color: var(--primary-color) !important;
                    border-radius: 8px;
                    font-size: 15px;
                    font-weight: 500;
                    letter-spacing: 2px;
                    color: #ffffff;
                    transition: all 0.2s ease;

                    &:hover {
                        background-color: var(--primary-color-hover) !important;
                        border-color: var(--primary-color-hover) !important;
                        box-shadow: 0 4px 12px rgba(48, 78, 114, 0.3);
                    }

                    &:active {
                        background-color: var(--primary-color) !important;
                        border-color: var(--primary-color) !important;
                    }

                    &.is-loading {
                        background-color: var(--primary-color) !important;
                    }
                }
            }
        }
}

@media only screen and (max-width: 1024px) {
    .boxlogo {
        .login_in_wrap {
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .brand {
            left: 20px;
            top: 18px;
            gap: 10px;

            .logo {
                height: 40px;
            }

            .brand-divider {
                height: 28px;
            }

            .brand-title {
                font-size: 16px;
            }

            .brand-subtitle {
                font-size: 9px;
                letter-spacing: 1.5px;
            }
        }
    }
}
</style>
